const DEV_HOSTNAME_MAP: Record<string, boolean> = {
  'localhost': true,
  'stage.pan-nft.com': true,
}

const withEnv = ({
  
} = {}) => {
  return {
    dev: DEV_HOSTNAME_MAP[window.location.hostname] ? true : false,
  }
}

export default withEnv